var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import Modal from '@fp-suite/core-ui/src/components/Modal';
import ButtonAnt from '@fp-suite/core-ui/src/components/ButtonAnt';
/**
 * Reusable confirmation modal for destructive or warning-level actions.
 * Shows a warning icon, a message, and a confirm/cancel pair of buttons.
 */
export var ConfirmActionModal = function (_a) {
    var visible = _a.visible, onClose = _a.onClose, onConfirm = _a.onConfirm, title = _a.title, message = _a.message, description = _a.description, children = _a.children, confirmText = _a.confirmText, cancelText = _a.cancelText, _b = _a.danger, danger = _b === void 0 ? true : _b, _c = _a.width, width = _c === void 0 ? '460px' : _c;
    var t = useTranslation().t;
    var _d = React.useState(false), loading = _d[0], setLoading = _d[1];
    var handleConfirm = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, onConfirm()];
                case 2:
                    _a.sent();
                    onClose();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error('ConfirmActionModal action failed:', error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [onConfirm, onClose]);
    return (_jsx(Modal, __assign({ title: title, visible: visible, onCancel: onClose, width: width }, { children: _jsxs("div", __assign({ className: 'space-y-4' }, { children: [_jsx("div", __assign({ className: 'flex justify-center py-2' }, { children: _jsx(ExclamationCircleOutlined, { className: danger ? 'text-red-500' : 'text-yellow-500', style: { fontSize: '44px' } }, void 0) }), void 0), _jsx("div", __assign({ className: "rounded border p-3 " + (danger ? 'border-red-200 bg-red-50' : 'border-yellow-200 bg-yellow-50') }, { children: _jsx("p", __assign({ className: "text-sm " + (danger ? 'text-red-800' : 'text-yellow-800') }, { children: message }), void 0) }), void 0), description && (_jsx("div", __assign({ className: 'rounded bg-gray-50 p-3' }, { children: _jsx("p", __assign({ className: 'text-xs text-gray-600' }, { children: description }), void 0) }), void 0)), children, _jsxs("div", __assign({ className: 'flex justify-end gap-2 pt-2' }, { children: [_jsx(ButtonAnt, { buttonText: cancelText || String(t('Cancel')), onClick: onClose, disabled: loading }, void 0), _jsx(ButtonAnt, { buttonText: confirmText || String(t('Confirm')), type: 'primary', danger: danger, onClick: handleConfirm, loading: loading }, void 0)] }), void 0)] }), void 0) }), void 0));
};
export default ConfirmActionModal;
